import { TransportService } from "../services/TransportService";
import { runInAction } from "mobx";

abstract class DataStore {
  transportService: TransportService;
  success: Set<string> = new Set();
  error: Set<string> = new Set();
  initialized: boolean = false;
  loading: Set<string> = new Set();

  setSuccess(success: string): void {
    runInAction(() => {
      this.success.add(success);
    });
  }

  clearSuccess(success: string): void {
    runInAction(() => {
      this.success.delete(success);
    });
  }

  setError(error: string): void {
    runInAction(() => {
      this.error.add(error);
    });
  }

  clearError(error: string): void {
    runInAction(() => {
      this.error.delete(error);
    });
  }

  setInitialized(initialized: boolean): void {
    runInAction(() => {
      this.initialized = initialized;
    });
  }

  setLoading(loading: string): void {
    runInAction(() => {
      this.loading.add(loading);
    });
  }

  clearLoading(loading: string): void {
    runInAction(() => {
      this.loading.delete(loading);
    });
  }

  protected constructor(transportService: TransportService) {
    this.transportService = transportService;
  }
}

export default DataStore;
